<template>
  <div :class="progress ? 'loading' : ''">
    <adv-cart-button
      :progress="progress"
      :stock="stock"
      :quantity="quantity"
      v-html="buttonBuyText"
      v-on:btn-click="btnBuyClicked"
      v-on:btn-click-no-stock="btnBuyClickedNoStock"
      v-show="showAddToCart"
      :disabled="setDisabled"
    ></adv-cart-button>
  </div>
</template>

<script>
import { forEach, isEqual, uniqWith } from 'lodash-es'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import onlineMixin from './mixins/onlineMixin'
import AdvCartButton from './AdvCartButton'
import cartButtonMixin from './mixins/cartButtonMixin'

export default {
  name: 'AdvButtonViewBuyCombo',
  mixins: [productMixin, onlineMixin, cartButtonMixin],
  props: {
    combo: {
      type: Array
    },
    showQuickView: {
      type: Boolean,
      default: false
    },
    productCodeIds: {
      type: Array
    },
    comboProductStocks: {
      type: Object
    },
    showAddToCart: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AdvCartButton
  },
  data () {
    return {
      version: '0.0.1',
      quickViewVisible: false,
      progress: false,
      comboProductIds: []
    }
  },
  computed: {
    setDisabled () {
      return !this.comboProductHasStock || !this.onlineStatus
    },
    stock () {
      return 1
    },
    comboProductHasStock () {
      for (const productId in this.comboProductStocks) {
        const product = this.comboProductStocks[productId]
        if (product.negative_stock === '0' && product.stock <= 0) {
          return false
        }
      }
      return true
    },
    quantity () {
      return store.getters.cartProductCodeQuantity(this.productCodeIds[1])
    },
    price () {
      return this.productData.productFinalPrice
    },
    buttonBuyText () {
      if (!this.comboProductHasStock) {
        return this.t('product_status.unavailable.coming_soon')
      }
      return this.t('product.button.text.buy.together')
    }
  },
  methods: {
    btnBuyClicked () {
      this.progress = true
      const addToCartPayload = {
        items: []
      }
      this.combo.forEach((item) => {
        const firstProductStockId = Object.keys(item.productStocks)[0]
        const firstProductCodeId = item.productStocks[firstProductStockId].product_code_id
        addToCartPayload.items.push({
          productCodeId: firstProductCodeId,
          quantity: store.getters.cartProductCodeQuantity(firstProductCodeId),
          cartProductCustomizations: null,
          recommendationId: item.recommendationId ?? null,
          recommendationType: item.recommendationType ?? null
        })
      })
      store.dispatch('comboAddToCartClicked', addToCartPayload)
        .then(() => {
          this.progress = false
        })
        .catch((error) => {
          this.progress = false
        })
    },
    btnBuyClickedNoStock () {
      // for clients that need click event without stock on button
    },
    allUniqueComboProductIds () {
      const allComboProductIds = []
      forEach(window.advAppData.comboProducts, (combo) => {
        forEach(combo, (product) => {
          allComboProductIds.push(Number(product.product_id))
        })
      })
      return uniqWith(allComboProductIds, isEqual)
    }
  },
  mounted () {
    this.comboProductIds = this.allUniqueComboProductIds()
  }
}
</script>
